export default "/images/vendor/flag-icon-css/flags/1x1/bm.svg?7dd1b92ad42d2f9d69dd785acff5c8da";